module.exports = __webpack_public_path__ + "img/viz-legend.1ea486cd.svg";